module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("emu6R"))).then(() => parcelRequire('f4eak'));